export const legalTermsUsageServiceUrlToggle =
  '/pages/conditions-generales-utilisation';
